import {
  ApplicationContext,
  EnvironmentContext,
  PlatformEnvironment,
} from '@wix/editor-platform-contexts';
import { PlatformAppEventEmitter } from '@wix/public-editor-platform-events';
import { IPrivateAPIFixMe } from './types';
import { IPlatformSDKContext } from '@wix/editor-platform-contexts';

export enum PlatformConsumerEnvironmentAPIType {
  Frame = 'PLATFORM_FRAME_API',
  Worker = 'PLATFORM_WORKER_API',
}

/**
 * rename these entities -> API to Env
 */
export abstract class AbstractEnvironmentAPI<
  TApiType extends PlatformConsumerEnvironmentAPIType,
  TEnv extends PlatformEnvironment,
> {
  protected constructor(
    public type: TApiType,
    public envType: TEnv,
  ) {}

  abstract initEnvironment(props: unknown): void;

  async injectEnvironmentContext({
    events,
    privateApi,
  }: {
    events: PlatformAppEventEmitter;
    privateApi: IPrivateAPIFixMe;
    applicationAPIs?: Record<string, any>;
  }) {
    await EnvironmentContext.inject({
      environment: this.envType,
      events,
      privateApi,
      applicationAPIs: {},
    });
  }

  async injectApplicationContext(context: IPlatformSDKContext) {
    await ApplicationContext.inject(context);
  }
}
